// extracted by mini-css-extract-plugin
export default {"component":"Policy_component__F3BwG","title":"Policy_title__h5Riz","text":"Policy_text__mCWQ0","gap":"Policy_gap__aB6TZ","linkTo":"Policy_linkTo__62o13"};